// this must be an object, for test purposes it's a function
var USE_MARKETPLACE = context => {
  var locale = context.locale.iso;
  var cookies = context.$cookies;
  var result = {
    'fr-FR': true,
    'nl-BE': false,
    'fr-BE': false,
    'de-DE': false,
    'es-ES': false,
    'it-IT': false,
    'fr-LU': false,
    'nl-NL': false,
    'de-AT': false,
    'pt-PT': false,
    'de-CH': false,
    'it-CH': false,
    'fr-CH': false,
    'en-GB': false
  };

  if (cookies.get('withoutmarketplaceproducts')) {
    result['fr-FR'] = false;
  }

  return result[locale];
};

export var mvpMartketplace = false;
export default USE_MARKETPLACE;